import { Card, CardMedia, Typography, styled } from '@mui/material';

export const CardStyled = styled(Card)(({ theme }) => ({
  minHeight: 76,
  display: 'flex',
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
}));

export const CardMediaStyled = styled(CardMedia)({
  margin: 'auto',
  height: 32,
  width: 32,
}) as typeof CardMedia;

export const TextStyled = styled(Typography)({
  display: 'flex',
  textAlign: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
}) as typeof Typography;
